<template>
    <v-data-table v-bind="{ headers, items }" disable-filtering disable-pagination disable-sort hide-default-footer :items-per-page="-1" class="v-sheet--outlined">
        <template #top>
            <v-subheader>HTTP Request Header</v-subheader>
            <v-divider />
        </template>

        <template #[`item.key`]="{item}">
            <v-text-field v-model="item.key" v-bind="attrs_input__table" @input="emit" />
        </template>
        <template #[`item.value`]="{item}">
            <v-text-field v-model="item.value" v-bind="attrs_input__table" @input="emit" />
        </template>
        <template #[`item.isActive`]="{ item }">
            <v-switch v-model="item.isActive" class="d-inline-block ml-1 mr-n3" v-bind="attrs_switch" @change="emit" />
        </template>
        <template #[`item.pull`]="{ item }">
            <v-btn text icon tile width="48" height="48" color="red" @click="pull(item)">
                <v-icon>mdi-minus</v-icon>
            </v-btn>
        </template>

        <template #footer>
            <v-divider />
            <v-row no-gutters>
                <v-spacer />
                <v-col cols="auto">
                    <v-btn text icon tile width="48" height="48" color="primary" @click="push">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </v-data-table>
</template>

<script>
import { attrs_input__table, attrs_switch } from "@/assets/variables/attrs";
import { initDataTableHeaders, initManufacturingVendorDigikey, initManufacturingVendorDigikeyOptionsHeader } from "@/assets/variables/inits";

const headers = initDataTableHeaders([
    { text: "key", value: "key", cellClass: "pa-0" },
    { text: "value", value: "value", cellClass: "pa-0" },
    { text: "", value: "pull", cellClass: "pa-0" },
]);

export default {
    props: {
        value: { type: Object, default: initManufacturingVendorDigikey },
    },
    data: () => ({
        form: initManufacturingVendorDigikey(),

        headers,
        attrs_switch,
        attrs_input__table,
    }),
    computed: {
        items() {
            return this.form?.options?.headers;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initManufacturingVendorDigikey(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        push() {
            this.form.options.headers.push(initManufacturingVendorDigikeyOptionsHeader());
            this.emit();
        },
        pull(item) {
            let index = (this.form?.options?.headers || []).findIndex(({ tempId }) => tempId == item.tempId);
            if (0 <= index) (this.form?.options?.headers || []).splice(index, 1);
            this.emit();
        },
    },
};
</script>
